import React from "react";

interface ArrowLeftIconProps {
  className?: string;
  onClick?: () => void;
}

export const ArrowLeftIcon = ({ className, onClick }: ArrowLeftIconProps) => (
  <svg
    width="12"
    height="22"
    viewBox="0 0 12 22"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M11.1562 21.3125C10.9062 21.5625 10.6562 21.5625 10.4062 21.3125L0.46875 11.375C0.21875 11.125 0.21875 10.875 0.46875 10.625L10.4062 0.6875C10.6562 0.4375 10.9062 0.4375 11.1562 0.6875L11.5312 1.0625C11.7812 1.3125 11.7812 1.57812 11.5312 1.85938L2.34375 11L11.5312 20.1406C11.7812 20.4219 11.7812 20.6875 11.5312 20.9375L11.1562 21.3125Z"
      fill="black"
    />
  </svg>
);

ArrowLeftIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
